import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormPageCard, FormPageCardProps } from '../FormPageCard';

export interface SettingsPageCardProps extends FormPageCardProps {}

export function _SettingsPageCard(props: SettingsPageCardProps) {
  return <FormPageCard {...props} />;
}

_SettingsPageCard.displayName = 'SettingsPageCard';

export const SettingsPageCard = observer(_SettingsPageCard);
